// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProfilesIndicator>ul{border:1px solid var(--colors-gray-200);list-style:none;padding:0;background-color:var(--colors-gray-50);border-radius:var(--radius-md)}.ProfilesIndicator>ul>li{padding:.5rem 1rem;border-bottom:1px solid var(--colors-gray-200)}.ProfilesIndicator>ul>li:last-child{border-bottom:none}.ProfilesIndicator label{margin:0;font-weight:600;display:inline}\n", ""]);
// Exports
module.exports = exports;
